import React from 'react';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { getTranslation } from '../../../../utils/getTranslation';
import { getRegion } from '../../../../utils/Region';
import './style.scss';

export const UserSuspendedBody = () => {
  const translations = useSelector(
    state => JSON.parse(state.metadata.translations).language[getRegion()],
  );
  const { link } = useSelector(
    selectMetadataKeyByRegion('suspended_refresh_hours_time'),
  );
  const urlToRedirect = getTranslation(link, translations) || '';

  return (
    <div className="user-suspended-body">
      <h1 className="user-suspended-body__title">
        {getTranslation('suspended_modal_title_label', translations)}
      </h1>
      <p className="user-suspended-body__description">
        <span className="user-suspended-body__description__label">
          {getTranslation('suspended_modal_description_label', translations)}
        </span>
        <span className="user-suspended-body__description__scope">
          {getTranslation('suspended_modal_scope_label', translations)}
        </span>
        <a
          className="user-suspended-body__description__link"
          href={urlToRedirect}
        >
          {getTranslation('suspended_modal_scope_link', translations) || ''}
        </a>
        <div className="user-suspended-body__description__text">
          <span>
            {getTranslation(
              'AlertaSuspensiondeCuenta_TextoDescriptivo1',
              translations,
            )}
          </span>
          {" "}
          <span>
            {getTranslation(
              'AlertaSuspensiondeCuenta_TextoDescriptivo2',
              translations,
            )}
          </span>
          {" "}
          <span>
            {getTranslation(
              'AlertaSuspensiondeCuenta_TextoDescriptivo3',
              translations,
            )}
          </span>
        </div>
      </p>
    </div>
  );
};
